import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const CreditCardsInput = observer(({ creditCard, creditCards, setCreditCardCallback }) => (
  <select
    className="ui dropdown creditCards"
    value={creditCard ? creditCard.id : ""}
    onChange={event => setCreditCardCallback(event.target.value)}
  >
    {creditCards.map(creditCardLookup => (
      <option key={creditCardLookup.id} value={creditCardLookup.id}>
        {creditCardLookup.brand} ****{creditCardLookup.last4}
        {creditCardLookup.is_default ? " (default)" : ""}
      </option>
    ))}
  </select>
));

const creditCardShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  last4: PropTypes.string.isRequired,
  brand: PropTypes.string,
  is_default: PropTypes.bool,
});

CreditCardsInput.propTypes = {
  creditCard: creditCardShape,
  creditCards: PropTypes.arrayOf(creditCardShape),
  setCreditCardCallback: PropTypes.func.isRequired,
};

export default CreditCardsInput;
